import { TenantStatusEnum } from '../enums/tenant-status.enum';

/**
 * Tenant statuses that block access when the override is AUTOMATIC.
 */
export const TENANT_ACCESS_BLOCKING_STATUSES = new Set<TenantStatusEnum>([
  TenantStatusEnum.UNPAID,
  TenantStatusEnum.PAUSED,
  TenantStatusEnum.CANCELED,
]);
